import { compactObjectMatchingValues } from '@retailer-platform/shared-common/src/objects/compact'
import {
  type CodeLookup,
  type CodeLookups,
  type CodeLookupsValidationErrors,
} from 'domains/collections/components/collections-form/components/code-lookup-matcher/utils/CodeLookupMatcher.types'

const validateCharacters = (codeLookup: CodeLookup) => /^\d+$/.test(codeLookup)

const validateLength = (codeLookup: CodeLookup) => codeLookup.length <= 13

const validateTotalCount = (codeLookups: CodeLookup[]) => codeLookups.length <= 500

// returns the indices of invalid codeLookups as an array
const findInvalidCodeLookups = (
  codeLookups: CodeLookups,
  validator: (codeLookup: CodeLookup) => boolean
) =>
  codeLookups.reduce<number[]>((invalidCodeLookups, codeLookup, index) => {
    const isValid = validator(codeLookup)

    if (!isValid) {
      invalidCodeLookups.push(index)
    }

    return invalidCodeLookups
  }, [])

export const parseCodeLookups = (originalString: string): CodeLookups =>
  originalString.split(/[ ,\s]+/).filter(codeLookup => codeLookup.trim().length > 0)

export const validateCodeLookups = (codeLookups: CodeLookups): CodeLookupsValidationErrors => {
  const invalidCharacters = findInvalidCodeLookups(codeLookups, validateCharacters)
  const invalidLength = findInvalidCodeLookups(codeLookups, validateLength)
  const invalidTotalCount = !validateTotalCount(codeLookups)

  // Compact away any "empty" or "false" values
  return compactObjectMatchingValues({ invalidTotalCount, invalidCharacters, invalidLength }, [
    [],
    false,
  ])
}
